<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onCarparkFilterChange" />

      <AppFilter 
        ref="typeFilter" 
        v-on:filter-data-change="onTypeFilterDataChange" />

      <AppFilter 
        ref="customerFilter" 
        filterKey="customerID"
        v-on:filter-data-change="onCustomerFilterDataChange" />

      <AppFilter 
        ref="licenseFilter" 
        filterKey="licenseID"
        v-on:filter-data-change="onLicenseFilterDataChange" />

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-cell-click="onTableCellClick"
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />
      
      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARKER_PARAM" 
        v-bind:permission="parkerPermission"
        v-on:modal-data-edit="onModalEditDataClick"
        v-bind:modalShowAdd="false"
        v-bind:modalShowDelete="false" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARKER_PARAM = [
  {
    key: 'name',
    text: 'Parker Full Name',
  },
  {
    key: 'mobile',
    text: 'Mobile No.',
    form_phone: true,
    form_input_attr: {
      placeholder: '60XXXXXXXXX',
    },
  },
  {
    key: 'car1',
    text: 'Car Plate',
  },
  {
    key: 'email',
    text: 'Email',
    form_email: true,
  }
];

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  // {
  //   key: '_customerType',
  //   text: 'Type',
  // },
  {
    key: 'parkingLicense',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['_licenseStatus'] === 'Pending' || dataItem['_licenseStatus'] === 'Pending Initial Payment' || dataItem['_licenseStatus'] === 'Terminated') {
        return helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum);
      }
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum)}</a>`;
    },
    form_hide: true, 
  },
  {
    key: '_customerAccount',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_customer'];
      if(!dataItem.id) {
        return '';
      }
      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      }
    },
    form_hide: true, 
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: '_zoneName',
    text: 'Zone',
  },
  {
    key: '_productName',
    text: 'Product Name',
  },
  {
    key: '_paymentPlan',
    text: 'Payment Plan',
  },
  {
    key: 'commencementDate',
    text: 'Commencement Date',
    table_custom: helper.tableCustomDate,
  },
  {
    key: 'nextBillDate',
    text: 'Next Billing Month',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(!dataItem['nextBillDate']) {
        return '';
      }
      let date = helper.parseDateTime(dataItem['nextBillDate']);
      return date ? date.format('MM/YYYY') : '';
    },
  },
  {
    key: '_parkingFee',
    text: 'Parking Fee (RM)',
  },
  {
    key: '_parkerInformation',
    text: 'Parker Information',
  },
  {
    key: 'status',
    text: 'Status',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['stopBillDate']) {
        return 'Stop Bill';
      }
      return dataItem['status']
    },
  },
  {
    key: 'isParkAide',
    text: 'Enable Parkaide',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['isParkAide'];
      return dataItem ? 'Yes' : 'No';
    },
  },
  {
    key: '_passcard',
    text: 'Passcard',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_passcard'];
      return (dataItem || {}).sku;
    },
  },
  {
    key: '_passcardStatus',
    text: 'Passcard Status',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);


const PASSCARD_PARAM = [
  {
    key: '_carparkName',
    text: 'Car Park',
    form_input_attr: { disabled: true },
  },
  {
    key: 'passcard',
    text: 'Passcard Number',
    form_select: {
      data: [],
      formatSelectOptionText: k => k.option,
    },
  },
];
const PASSCARD_PARAM_MAP = helper.transformParamToMap(PASSCARD_PARAM);

export default {
  name: "PagePLLease",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
        { name: 'Subscription' },
      ],

      PARAM,
      PARAM_MAP,
      PARKER_PARAM,

      PASSCARD_PARAM,
      PASSCARD_PARAM_MAP,

      isInitialSetCustomer: true,

      pagePasstype: null,
      pageCarpark: null,
      pageZone: null,
      pagePasstype: null,
      pagePasscard: null,
      pageCustomer: null,
      pageLease: null,
      pageSeason: null,
      pageSeasonFees: {},
      pageParker: null,

      parkerPermission: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['customerFilter'].formatFilterOptionText = (dataItem) => dataItem.nationalID ? `${dataItem.name} (${dataItem.nationalID})` : dataItem.name;
    this.$refs['licenseFilter'].formatFilterOptionText = (dataItem) => { 
      let text = helper.plFormPLNum(dataItem.licenseOperatorNum, dataItem.carparkID);
      if(dataItem['_customer']) {
        text = (dataItem['_customer'] ? dataItem['_customer']['name'] : '') + ' - ' + text;
      } else {
        text = 'All Customers';
      }
      return text;
    };
    this.loadPasscardType();
  },
  methods: {
    loadPasscardType() {
      let feedbackItem = 'passcard type data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/passtype/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasstype = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, this.pageCarpark), this.$route.query.carparkID);
          this.loadZone();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      let feedbackItem = 'zone data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCustomer = response.data;
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCustomerFilter() {
      let filterData = this.pageCustomer.filter(k => this.$refs['typeFilter'].filterValue === 'Company' ? k.isCompany : !k.isCompany);
      filterData = filterData.filter(k => this.pageLicense.find(j => helper.compareID(j.customerID, k['id'])));
      this.$refs['customerFilter'].setFilterDataWithValueIfFirstLoad(filterData, this.$route.query.customerID);
    },
    setLicenseFilter() {
      let filterData = this.pageLicense.filter(k => {
        if(!k['_customer']) return;
        if(this.$refs['typeFilter'].filterValue === 'Company') {
          return k['_customer'].isCompany
        } else {
          return !k['_customer'].isCompany
        }
      });
      this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Customer'}, filterData), this.$route.query.licenseID);
      // this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad(filterData, this.$route.query.licenseID);
    },
    loadLicense() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/';

      let feedbackItem = 'license data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;

          if(response.data && response.data.length > 0) {
            response.data.forEach(k => {
              k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
              k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
            });

            if(helper.checkRoleIsParker()) {
              // if(helper.checkRoleIsCompany()) {
              //   this.$refs['typeFilter'].setFilterDataWithDefault([{id:'Company', name:'Company'}]);
              // } else {
              //   this.$refs['typeFilter'].setFilterDataWithDefault([{id:'Personal', name:'Personal'}]);
              // }
              this.$refs['typeFilter'].setFilterDataWithDefault([{id:'Company', name:'Company'}, {id:'Personal', name:'Personal'}]);
            } else {
              this.$refs['typeFilter'].setFilterDataWithDefault([{id:'Company', name:'Company'}, {id:'Personal', name:'Personal'}]);
            }

            // let setCustomerFilter = false;
            // if(this.isInitialSetCustomer) {
            //   this.isInitialSetCustomer = false;
            //   let customerID = this.$route.query.customerID;
            //   if(customerID) {
            //     let customer = this.pageCustomer.find(k => helper.compareID((k.id, customerID)));
            //     if(customer) {
            //       this.$refs['typeFilter'].setFilterValue(customer.isCompany ? 'Company' : 'Personal');
            //       this.setCustomerFilter();
            //       setCustomerFilter = true;
            //     }
            //   }
            // }

            // if(!setCustomerFilter) {
            //   this.setCustomerFilter();
            // }

            let setLicenseFilter = false;
            if(this.isInitialSetCustomer) {
              this.isInitialSetCustomer = false;
              let licenseID = this.$route.query.licenseID;
              if(licenseID) {
                let customerID = (this.pageLicense.find(k => helper.compareID(k.id, licenseID)) || {})['customerID'];
                let customer = (this.pageCustomer.find(k => helper.compareID(k.id, customerID)) || {});
                if(customer) {
                  this.$refs['typeFilter'].setFilterValue(customer.isCompany ? 'Company' : 'Personal');
                  this.setLicenseFilter();
                  setLicenseFilter = true;
                }
              }
            }

            if(!setLicenseFilter) {
              this.setLicenseFilter();
            }

            this.loadPasscard();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No license data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscard() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/passcard/';

      let feedbackItem = 'passcard data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          response.data.forEach(k => {
            let passtype = this.pagePasstype.find(j => j.id === k.passtypeID);
            k['option'] = passtype ? k['sku'] + ' - ' + passtype.name : k['sku'];
          });
          this.loadLease();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLease() {
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['licenseFilter'].filterValue) {
        url += '/license/' + this.$refs['licenseFilter'].filterValue;
      } else if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/lease/';
      if(this.$refs['typeFilter'].filterValue === 'Personal') {
        url += '?isCompany=0';
      } else {
        url += '?isCompany=1';
      }
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());

      let feedbackItem = 'lease data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage('');
            response.data = response.data.filter(k => {
              let temp = this.pageCustomer.find(j => helper.compareID(j.id, k['customerID'])) || {};
              return this.$refs['typeFilter'].filterValue === 'Company' ? temp['isCompany'] : !temp['isCompany'];
            });
            this.pageLease = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No lease data available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLeaseData() {
      this.$refs['pageTable'].setTableData(null);

      if(!this.$refs['licenseFilter'].filterData || this.$refs['licenseFilter'].filterData.length === 0) {
        return;
      }

      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      let temp = this.pageLease;
      for(let leaseData of temp) {
        if(leaseData['seasonID'] && this.pageSeasonFees[leaseData['seasonID']] === undefined) {
          // load season fees
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };

      temp.forEach(k => {
        k['_license'] = this.pageLicense.find(j => helper.compareID(j.id, k['licenseID'])) || {};
        k['_licenseStatus'] = (k['_license'] || {})['status'];
        k['_licenseNum'] = (k['_license'] || {})['licenseOperatorNum'];
        k['_carparkNum'] = (k['_license'] || {})['carparkID'];
        k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']);
        k['_customerType'] = (k['_customer'] || {}).isCompany ? 'Company' : 'Personal';
        k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']);
        k['_carparkName'] = (k['_carpark'] || {}).name;

        k['_product'] = this.pageSeason.find(j => j.id === k['seasonID']);
        k['_productName'] = (k['_product'] || {}).name;
        k['_parker'] = this.pageParker.find(j => j.id === k['parkerID']);
        k['_parkerInformation'] = helper.plFormParker(k['_parker'], true);

        if(k['isParkAide']) {
          k['_passcardStatus'] = 'ParkAide Blocked';

          if(k['status'] === 'Active' || k['status'] === 'Pending Termination') {
            if(new moment() > helper.parseDateTime(k['commencementDate'])) {
              if(!k['isBlock']) {
                k['_passcardStatus'] = 'ParkAide Active';
              }
            }
          }
        } else {
          if(k['passcardID']) {
            k['_passcard'] = this.pagePasscard.find(j => helper.compareID(j.id, k['passcardID']));
            k['_passcardStatus'] = 'Passcard Issued';
          } else {
            if(k['status'] === 'Active' || k['status'] === 'Stop Bill') {
              if(k['reason'].includes('Pending')) {
                k['_passcardStatus'] = 'Pending Passcard Issuence';
              } else {
                k['_passcardStatus'] =  k['reason'] + ' Passcard';
              }
            } else if(k['status'] === 'Pending Termination' || k['status'].includes('Terminated')) {
              if(k['reason'].includes('Pending')) {
                k['_passcardStatus'] = 'Pending Passcard Issuence';
              } else if(k['reason'].includes('Returned')) {
                k['_passcardStatus'] = 'Passcard Returned';
              } else {
                k['_passcardStatus'] =  k['reason'] + ' Passcard';
              }
            }
          }
        }

        let selectedSeasonFee = this.pageSeasonFees[k['seasonID']].find(j => j.isActive)
        if(!selectedSeasonFee) {
          for(let temp of this.pageSeasonFees[k['seasonID']]) {
            if(temp.startDate <= k.commencementDate) {
              selectedSeasonFee = temp;
              break;
            }
          }
        }
        selectedSeasonFee = selectedSeasonFee || {};
        switch(parseInt(k['paymentPlan'])) {
          case 1:
            k['_paymentPlan'] = 'Monthly';
            k['_parkingFee'] = helper.formatMoney(selectedSeasonFee['monthly']) + ' / month';
            break;
          case 2:
            k['_paymentPlan'] = 'Quarterly';
            k['_parkingFee'] = helper.formatMoney(selectedSeasonFee['quarterly'] * 3) + ' / quarter';
            break;
          case 3:
            k['_paymentPlan'] = 'Half-yearly';
            k['_parkingFee'] = helper.formatMoney(selectedSeasonFee['halfYearly'] * 6) + ' / half-year';
            break;
          case 4:
            k['_paymentPlan'] = 'Annually';
            k['_parkingFee'] = helper.formatMoney(selectedSeasonFee['annually'] * 12) + ' / annual';
            break;
        }

        k['_zone'] = this.pageZone.find(j => j.id === (k['_product'] || {})['zoneID']);
        k['_zoneName'] = (k['_zone'] || {}).name;
      });

      // temp = temp.filter(k => k['_customer'] && (this.$refs['typeFilter'].filterValue === 'Company' ? k['_customer'].isCompany : !k['_customer'].isCompany));
      
      // let filterCustomer = this.$refs['customerFilter'].filterValue;
      // if(filterCustomer) {
      //   temp = temp.filter(k => k['_customer'] && helper.compareID(k['_customer']['id'], filterCustomer));
      // }
      
      this.$refs['pageTable'].setTableData(temp, this.$refs['pageTable'].getCurrentPage());
    },
    loadSeason() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/season/';

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageSeason = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No product data available.');
          }
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.pageSeasonFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/seasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // if(response.data && response.data.length > 0) {
          //   // if(this.pageSeasonFees[seasonID] = response.data[0]) {
          //   if(this.pageSeasonFees[seasonID] = response.data) {
          //     this.$refs['pageFeedback'].setFeedbackMessage();
          //     this.loadLeaseData();
          //   } else {
          //     this.$refs['pageFeedback'].setFeedbackError('No active product fees data available.');
          //   }
          // } else {
          //   this.$refs['pageFeedback'].setFeedbackError('No product fees data available.');
          // }

          // TODO die die continue loading even though no valid fees
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageSeasonFees[seasonID] = response.data || [];
          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pageParker = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No parker available.');
          }
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    onTablePageChange() {
      this.loadLease();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadLease();
    },
    onCarparkFilterChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['typeFilter'].setFilterData(null);
      this.$refs['licenseFilter'].setFilterData(null);
      this.$refs['pageTable'].setTableData(this.pageLease = null);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadLicense();
    },
    onTypeFilterDataChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      // this.setCustomerFilter();
      // this.loadLeaseData();
      this.setLicenseFilter();
      this.pageSeason = null;
      this.pageParker = null;
      this.loadLease();
    },
    onCustomerFilterDataChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadLeaseData();
    },
    onLicenseFilterDataChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      this.pageSeason = null;
      this.pageParker = null;
      this.loadLease();
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      
      let defaultData = this.$refs['pageModal'].$refs['modalForm'].getFormDefaultData();
      defaultData['carparkID'] = this.$refs['carparkFilter'].filterValue;

      this.$refs['pageModal'].setModalOpen(true, 'Add New Car Park Level', defaultData);
    },
    onTableDataClick(tableData, tableDataIndex) {
    },
    onTableCellClick(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      let selectedData = tableData[tableDataIndex];
      if(tableParameter[tableParameterIndex]['key'] === '_parkerInformation') {
        if(selectedData['_customer']) {
          this.parkerPermission = selectedData['_customer']['isCompany'] ? 'company_parker' : 'personal_parker';
        } else {
          this.parkerPermission = this.$refs['typeFilter'].filterValue === 'Company' ? 'company_parker' : 'personal_parker';
        }

        if(selectedData.parkerID) {
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.$refs['pageModal'].setModalOpen(false, 'Parker', tableData[tableDataIndex]);
          this.$refs['pageModal'].modalFormVisible = false;
          this.$refs['pageModal'].modalCanAdd = false;
          this.$refs['pageModal'].modalCanEdit = false;
          this.$refs['pageModal'].modalCanDelete = false;

          this.$refs['pageModal'].$refs['modalFeedback'].setFeedbackLoading('Loading parker detail');
          this.$http
            .get(
              helper.SERVER_URL + '/api2/customer/' + selectedData.customerID + '/parker/',// + selectedData.parkerID,
              helper.createAxiosConfig()
            )
            .then(response => {
              let resultMeta = helper.processAxiosResponse(this, response);
              this.$refs['pageModal'].$refs['modalFeedback'].setFeedbackMessage();
              let parker = response.data.find(k => helper.compareID(k.id, selectedData.parkerID));

              if(parker) {
                this.$refs['pageModal'].modalCanEdit = true;
                this.$refs['pageModal'].modalFormVisible = true;
                this.$refs['pageModal'].setModalOpen(false, 'Edit Parker ' + parker['name'], parker);
              } else {
                this.$refs['pageModal'].$refs['modalFeedback'].setFeedbackError('Problem loading parker detail');
              }
            })
            .catch(error => {
              this.$refs['pageModal'].$refs['modalFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'parker detail'));
            })
        }
      }
    },

    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadLease();
    },

    onModalEditDataClick(selectedData) {
      let parkerMobile = selectedData['mobile'] || '';
      if(!parkerMobile.startsWith('6')) {
        let error = 'Phone number must start with 6 e.g. 60121234567';
        this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-mobile'][0].setInputError(error);
        return true;
      }
      if(parkerMobile.startsWith('6011')) {
        if(parkerMobile.length !== 12) {
          let error = 'Phone number start with 6011 must have 12 digits e.g. 601112345678';
          this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-mobile'][0].setInputError(error);
          return true;
        }
      } else if(parkerMobile.startsWith('601')) {
        if(parkerMobile.length !== 11) {
          let error = 'Phone number start with 601 must have 11 digits e.g. 60121234567';
          this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-mobile'][0].setInputError(error);
          return true;
        }
      }
      this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-mobile'][0].setInputError();
      
      this.$refs['pageModal'].$refs['modalFeedback'].setFeedbackLoading('Updating parker');
      this.$http
        .put(
          helper.SERVER_URL + '/api2/customer/' + selectedData.customerID + '/parker/' + selectedData.id,
          querystring.stringify(selectedData),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageModal'].$refs['modalFeedback'].setFeedbackMessage();
          this.$refs['pageModal'].setModalClose();
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully update parker');
          this.pageParker = null;
          this.loadLease();
        })
        .catch(error => {
          this.$refs['pageModal'].$refs['modalFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', 'parker'));
        })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLLease.vue